// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function localDraftAttachmentStatus_decode($$enum) {
  if ($$enum === "Failed" || $$enum === "InProgress") {
    return $$enum;
  }
}

let localDraftAttachmentStatus_fromString = localDraftAttachmentStatus_decode;

function localDraftSaveStatus_decode($$enum) {
  if ($$enum === "NotSaved" || $$enum === "SaveFailed" || $$enum === "FirstSaveInProgress" || $$enum === "Saved" || $$enum === "SaveInProgress") {
    return $$enum;
  }
}

let localDraftSaveStatus_fromString = localDraftSaveStatus_decode;

function localGeocodingStatus_decode($$enum) {
  if ($$enum === "NotCalled" || $$enum === "ErrorOutsideChapterBoundaries" || $$enum === "Called" || $$enum === "ErrorDuplicateListing" || $$enum === "Valid" || $$enum === "Error") {
    return $$enum;
  }
}

let localGeocodingStatus_fromString = localGeocodingStatus_decode;

let Utils = {
  localDraftAttachmentStatus_decode: localDraftAttachmentStatus_decode,
  localDraftAttachmentStatus_fromString: localDraftAttachmentStatus_fromString,
  localDraftSaveStatus_decode: localDraftSaveStatus_decode,
  localDraftSaveStatus_fromString: localDraftSaveStatus_fromString,
  localGeocodingStatus_decode: localGeocodingStatus_decode,
  localGeocodingStatus_fromString: localGeocodingStatus_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardRelayPreviewGlobalValidityIndicator_formState",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardFormRelayValidators_formState"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filesStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imagesStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "geocodingStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "draftSaveStatus",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraftFormState",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
